{
  "tabs": {
    "label": "หน้าการชำระเงิน",
    "methods": "วิธีชำระเงิน",
    "reconciliation": "รายการเดินบัญชีเครื่องรูดบัตร",
    "refunds": "การคืนเงิน"
  },
  "page": {
    "intro": "ลูกค้าจ่ายเงินบนเว็บและหน้าร้านได้อย่างไร ค่าธรรมเนียมเครื่องรูดบัตรระบบคำนวณจากค่าที่ตั้งไว้นี้",
    "load_failed": "โหลดการตั้งค่าการชำระเงินไม่ได้",
    "read_only": "คุณดูการตั้งค่านี้ได้ เปลี่ยนได้เฉพาะเจ้าของร้าน",
    "add_title": "ยังไม่ได้ตั้ง",
    "add": "เพิ่ม {{name}}"
  },
  "state": {
    "on": "เปิด",
    "off": "ปิด"
  },
  "channels": {
    "web": "เว็บไซต์",
    "web_desc": "ลูกค้าเลือกได้ตอนสั่งซื้อ",
    "pos": "เคาน์เตอร์หน้าร้าน",
    "pos_desc": "พนักงานรับที่เครื่อง POS"
  },
  "save": "บันทึก",
  "saved": "บันทึก {{name}} แล้ว",
  "confirm_title": "บันทึก {{name}} ไหม?",
  "confirm_consequence": "ลูกค้าและเครื่อง POS ใช้ค่าใหม่ทันที การเปลี่ยนแปลงเก็บในประวัติ (ใคร เมื่อไร ก่อนและหลัง)",
  "pos_empty": "หน้าร้านต้องมีวิธีชำระอย่างน้อยหนึ่งวิธี — เปิดวิธีอื่นก่อน",
  "warnings": {
    "needs_review": "เป็นค่าตัวอย่าง — ตรวจกับสัญญาจริงก่อน",
    "provider_phase_2": "วิธีชำระนี้มาทีหลัง ปิดไว้จนกว่าจะถึงเวลา",
    "bank_account_missing": "ลูกค้ายังโอนเงินไม่ได้ — เพิ่มบัญชีธนาคารของร้าน",
    "translations_missing": "บางภาษายังไม่มีข้อความ — ลูกค้าจะเห็นภาษาอังกฤษแทน",
    "fee_percent_high": "ค่าธรรมเนียมบัตรเกิน 5% — โปรดตรวจอีกครั้ง",
    "pickup_location_missing": "ไม่มีร้านที่รับของได้ — ลูกค้าเลือกจ่ายที่ร้านไม่ได้",
    "pickup_location_unverified": "ตอนนี้ตรวจร้านรับของไม่ได้"
  },
  "bank": {
    "title": "โอนธนาคาร (銀行振込)",
    "desc": "วิธีชำระหลักบนเว็บตอนนี้ พนักงานยืนยันเมื่อเงินเข้า",
    "account": "บัญชีธนาคารของร้าน",
    "bank_name": "ชื่อธนาคาร",
    "bank_code": "รหัสธนาคาร (4 หลัก)",
    "bank_name_en": "ชื่อธนาคาร (อังกฤษ)",
    "branch_name": "ชื่อสาขา",
    "branch_code": "รหัสสาขา (3 หลัก)",
    "branch_name_en": "ชื่อสาขา (อังกฤษ)",
    "account_type": "ประเภทบัญชี",
    "futsu": "ออมทรัพย์ (普通)",
    "toza": "กระแสรายวัน (当座)",
    "account_number": "เลขบัญชี (7 หลัก)",
    "account_name": "ชื่อบัญชี (คาตาคานะ)",
    "account_name_help": "ตามที่ธนาคารเขียน เป็นตัวคาตาคานะ",
    "problem_required": "ต้องกรอก {{field}}",
    "problem_format": "{{field}} ดูไม่ถูกต้อง",
    "fix_account": "ตรวจช่องบัญชีที่เป็นสีแดง",
    "instructions": "ข้อความที่ลูกค้าเห็น",
    "instructions_field": "วิธีโอนเงิน",
    "instructions_hint": "แสดงในหน้าออเดอร์ อีเมล และหน้าติดตาม ต้องมีอังกฤษและญี่ปุ่น ภาษาอื่นถ้าไม่มีจะใช้อังกฤษ",
    "missing_locale": "ยังไม่มี{{language}} (จะใช้ภาษาอังกฤษ)",
    "text_en_ja": "เขียนข้อความเป็นภาษาอังกฤษและญี่ปุ่น",
    "days": "จำนวนวันที่ให้โอน",
    "days_help": "การ์ดจะถูกกันไว้ให้ลูกค้าจนถึงวันนั้น",
    "days_hint": "1 ถึง 14 วัน (ปกติ 3 วัน)",
    "days_range": "เลือก 1 ถึง 14 วัน",
    "singles": "การ์ดใบเดี่ยวจ่ายด้วยการโอนเงินได้",
    "singles_on": "เปิด: ลูกค้าจ่ายการ์ดทุกใบด้วยการโอนเงินได้ (เก็บการ์ดไว้ให้จนกว่าเงินจะเข้า)",
    "singles_off": "ปิด: ถ้าในตะกร้ามีการ์ดใบเดี่ยว จะไม่มีตัวเลือกโอนเงิน สินค้าซีลยังจ่ายด้วยการโอนเงินได้",
    "singles_help": "ระหว่างรอเงินโอน การ์ดใบเดี่ยวจะถูกเก็บไว้ให้ลูกค้า ปิดตัวเลือกนี้ถ้าไม่อยากเก็บการ์ดที่มีใบเดียวไว้นาน",
    "singles_none_left": "ลูกค้าที่อยากให้ส่งการ์ดใบเดี่ยวไปให้จะไม่มีทางจ่ายเงินออนไลน์เลย — ทำได้แค่มารับที่ร้าน ถ้ายังอยากขายการ์ดใบเดี่ยวแบบส่งไปรษณีย์ ให้เปิดวิธีจ่ายอื่นที่ใช้กับการส่งของก่อน"
  },
  "locale": {
    "en": "ภาษาอังกฤษ",
    "ja": "ภาษาญี่ปุ่น",
    "th": "ภาษาไทย",
    "zh-Hant": "ภาษาจีน (ตัวเต็ม)",
    "zh-Hans": "ภาษาจีน (ตัวย่อ)"
  },
  "simple": {
    "cash": {
      "title": "เงินสด (現金)",
      "desc": "ที่เคาน์เตอร์หน้าร้าน"
    },
    "pay_in_store": {
      "title": "จ่ายตอนรับของ (店頭払い)",
      "desc": "ลูกค้าสั่งบนเว็บแล้วจ่ายตอนมารับ"
    },
    "pickup_days": "จำนวนวันที่รอรับของ",
    "pickup_days_help": "เกินจากนี้ออเดอร์ถูกยกเลิกและการ์ดกลับไปขาย",
    "days_range": "เลือก 1 ถึง 30 วัน"
  },
  "store_credit": {
    "title": "เครดิตร้าน",
    "desc": "เครดิตที่ร้านให้ลูกค้า (คืนสินค้า รับซื้อ)",
    "months": "เครดิตใช้ได้",
    "months_help": "เครดิตที่นานเกิน 6 เดือนนับเป็นวิธีชำระล่วงหน้าตาม 資金決済法 (ต้องรายงานและวางเงินประกัน)",
    "month_option_other": "{{count}} เดือน",
    "max": "นานสุดที่อนุญาต",
    "law": "資金決済法 — ร้านตั้งไว้ไม่เกิน 6 เดือน"
  },
  "edc": {
    "title": "เครื่องรูดบัตร (EDC)",
    "intro": "เครื่องรูดบัตรที่หน้าร้าน ค่าธรรมเนียมของทุกการขายด้วยบัตรคิดจากค่าเหล่านี้",
    "add": "เพิ่มเครื่อง (端末を追加)",
    "add_title": "เพิ่มเครื่องรูดบัตร",
    "edit": "แก้ค่าธรรมเนียม",
    "edit_title": "เครื่องรูดบัตร {{name}}",
    "dialog_desc": "ค่าธรรมเนียมตามสัญญาเครื่องรูดบัตร",
    "card_desc": "เครื่องรูดบัตรที่หน้าร้าน",
    "none": "ยังไม่มีเครื่องรูดบัตร",
    "needs_review": "ตรวจค่าธรรมเนียมตัวอย่าง",
    "name": "ชื่อเครื่อง",
    "name_placeholder": "เครื่อง 1",
    "name_required": "ตั้งชื่อเครื่อง",
    "company": "บริษัทบัตร",
    "company_help": "บริษัทในสัญญาเครื่อง (สำหรับร้าน — ลูกค้าไม่เห็น)",
    "fee_percent": "ค่าธรรมเนียม (%)",
    "fee_percent_help": "% ปกติตามสัญญา แต่ละแบรนด์ตั้ง % เองได้ด้านล่าง",
    "fee_fixed": "ค่าธรรมเนียมคงที่ต่อครั้ง",
    "fee_fixed_help": "บางสัญญาบวกเงินคงที่ทุกครั้งที่จ่าย",
    "percent_format": "เขียน % แบบ 3.24",
    "percent_max": "สูงสุด 10%",
    "percent_high": "เกิน 5% — โปรดตรวจอีกครั้ง",
    "fix_percent": "ตรวจช่อง % ที่เป็นสีแดง",
    "brands": "ค่าธรรมเนียมตามแบรนด์บัตร",
    "brands_hint": "ว่าง = ใช้ % ปกติของเครื่อง เอาเครื่องหมายออกสำหรับแบรนด์ที่เครื่องไม่รับ",
    "brand_percent": "ค่าธรรมเนียม {{brand}} เป็น %",
    "more_brands": "แบรนด์อื่น (UnionPay, iD, QUICPay, บัตร IC…)",
    "fewer_brands": "ลดแบรนด์",
    "not_accepted": "ไม่รับ",
    "bearer": "ใครรับภาระค่าธรรมเนียม",
    "bearer_help": "ร้าน, ผู้ฝากขาย (ตามสัดส่วน) หรือลูกค้า",
    "surcharge_warning": "การบวกค่าธรรมเนียมบัตรให้ลูกค้าจ่ายอาจผิดกฎเครือข่ายบัตรและสัญญาเครื่องรูดบัตรในญี่ปุ่น — ปรึกษาผู้ให้บริการบัตรก่อน",
    "surcharge_ack": "ตรวจสอบกฎการเก็บค่าธรรมเนียมเพิ่มแล้ว",
    "ack_required": "ติ๊ก \"ตรวจสอบกฎการเก็บค่าธรรมเนียมเพิ่มแล้ว\" ก่อน",
    "min_amount": "ยอดต่ำสุด (ไม่บังคับ)",
    "max_amount": "ยอดสูงสุด (ไม่บังคับ)",
    "preview_after_percent": "ตัวอย่างจะแสดงเมื่อกรอก %",
    "save": "บันทึก",
    "confirm_add": "เพิ่มเครื่องนี้ไหม?",
    "confirm_edit": "บันทึกค่าธรรมเนียมใหม่ไหม?",
    "confirm_consequence": "ทุกการจ่ายด้วยบัตรบนเครื่องนี้ต่อจากนี้ใช้ค่าธรรมเนียมนี้ เก็บในประวัติ",
    "summary_default": "ค่าธรรมเนียมปกติ: {{percent}}%"
  },
  "bearer": {
    "shop": "ร้าน",
    "shop_desc": "ร้านจ่ายค่าธรรมเนียมทั้งหมด",
    "consignor_pro_rata": "ผู้ฝากขายตามสัดส่วน",
    "consignor_pro_rata_desc": "ผู้ฝากขายจ่ายส่วนของการ์ดตัวเอง",
    "customer_surcharge": "ลูกค้า",
    "customer_surcharge_desc": "บวกในบิลลูกค้า — ตรวจกฎก่อน"
  },
  "bearer_short": {
    "shop": "ร้านรับ",
    "consignor_pro_rata": "ผู้ฝากขายรับตามสัดส่วน",
    "customer_surcharge": "ลูกค้าจ่าย"
  },
  "brand": {
    "VISA": "Visa",
    "MASTER": "Mastercard",
    "JCB": "JCB",
    "AMEX": "American Express",
    "DINERS": "Diners Club",
    "DISCOVER": "Discover",
    "UNIONPAY": "UnionPay (銀聯)",
    "ID": "iD",
    "QUICPAY": "QUICPay",
    "SUICA_TRANSIT": "บัตร IC (Suica ฯลฯ)",
    "PAYPAY_VIA_EDC": "PayPay (เครื่อง)",
    "OTHER": "อื่นๆ"
  },
  "fee_preview": {
    "title": "ตัวอย่าง",
    "updating": "กำลังอัปเดตตัวอย่าง",
    "amount": "ยอด",
    "brand": "บัตร",
    "fee": "ค่าธรรมเนียม",
    "net": "ร้านได้รับ"
  },
  "stripe": {
    "title": "ชำระด้วยบัตรออนไลน์",
    "will_add": "วิธีที่จะเพิ่มเมื่อเชื่อมบัตร",
    "method": {
      "card": "บัตร",
      "apple_pay": "Apple Pay",
      "google_pay": "Google Pay",
      "konbini": "ร้านสะดวกซื้อ (コンビニ)",
      "paypay": "PayPay"
    }
  },
  "reconcile": {
    "title": "รายการเดินบัญชีเครื่องรูดบัตร",
    "intro": "อัปโหลดรายการของเครื่องรูดบัตรหนึ่งเดือน ระบบจับคู่ทุกบรรทัดกับการจ่ายด้วยบัตรที่บันทึกไว้ และแสดงสิ่งที่ไม่ตรง",
    "result_intro": "อะไรตรง อะไรไม่ตรง และต้องทำอะไร",
    "no_terminal": "ยังไม่มีเครื่องรูดบัตร",
    "no_terminal_body": "เพิ่มเครื่องในหน้า วิธีชำระเงิน ก่อน",
    "terminal": "เครื่อง",
    "month": "เดือน",
    "choose_file": "เลือกรายการ (CSV)",
    "file_required": "เลือกไฟล์รายการ",
    "check": "ตรวจรายการ",
    "reading": "กำลังอ่านรายการ…",
    "choose_columns": "หาคอลัมน์ของไฟล์นี้ไม่เจอ — เลือกด้านล่างครั้งเดียว เครื่องจะจำไว้",
    "columns": "คอลัมน์ไหนคืออะไร",
    "columns_hint": "ต้องมีวันที่และยอด ยิ่งเลือกมากยิ่งจับคู่แม่น",
    "columns_required": "เลือกคอลัมน์วันที่และยอด",
    "not_in_file": "ไม่มีในไฟล์",
    "field": {
      "date": "วันที่",
      "amount": "ยอด",
      "approvalCode": "เลขอนุมัติ (承認番号)",
      "last4": "เลขท้ายบัตร 4 หลัก",
      "brand": "แบรนด์บัตร",
      "fee": "ค่าธรรมเนียม",
      "time": "เวลา",
      "kind": "ขายหรือยกเลิก"
    },
    "duplicate": "รายการนี้ตรวจไปแล้ว",
    "open_existing": "เปิดดู",
    "history": "รายการที่ตรวจแล้ว",
    "batch_status": {
      "uploaded": "ได้รับแล้ว",
      "parsing": "กำลังอ่าน",
      "open": "มีเรื่องต้องตรวจ",
      "reconciled": "ตรงทั้งหมด",
      "failed": "อ่านไม่ได้"
    },
    "export": "ดาวน์โหลด (CSV)",
    "another": "ตรวจรายการอื่น",
    "statement_gross": "ยอดขายในรายการ",
    "expected_gross": "ยอดขายบัตรในระบบ",
    "statement_fee": "ค่าธรรมเนียมในรายการ",
    "expected_fee": "ค่าธรรมเนียมที่ระบบคาด",
    "fee_difference": "ต่างกัน:",
    "groups": "บรรทัด",
    "group": {
      "matched": "ตรง",
      "variance": "ค่าธรรมเนียมต่าง",
      "unmatched": "ไม่มีในระบบ",
      "missing_in_statement": "ไม่มีในรายการ",
      "ignored": "ตรวจแล้ว"
    },
    "group_help": {
      "matched": "บรรทัดในรายการตรงกับการจ่ายที่บันทึก",
      "variance": "พบการจ่ายแล้ว แต่ผู้ให้บริการคิดค่าธรรมเนียมต่างไป",
      "unmatched": "เครื่องมีแต่ระบบไม่มี — จับคู่เองหรือทำเครื่องหมายว่าตรวจแล้ว",
      "missing_in_statement": "ระบบมีแต่ไม่มีในรายการ — ตรวจกับผู้ให้บริการ",
      "ignored": "บรรทัดที่ทำเครื่องหมายว่าตรวจแล้ว พร้อมหมายเหตุ"
    },
    "group_empty": "ไม่มี",
    "line": "บรรทัด",
    "date": "วันที่",
    "amount": "ยอด",
    "card": "บัตร",
    "fee": "ค่าธรรมเนียม",
    "expected": "ค่าธรรมเนียมที่คาด",
    "difference": "ต่าง",
    "order": "ออเดอร์",
    "what": "สถานะ",
    "match": "จับคู่",
    "match_title": "จับคู่บรรทัด {{line}}",
    "match_desc": "เลือกการจ่ายด้วยบัตรที่เป็นของบรรทัดนี้ ยอดเท่ากันขึ้นก่อน",
    "no_candidates": "ไม่มีการจ่ายด้วยบัตรของเครื่องนี้ในช่วงนี้",
    "matched": "จับคู่แล้ว",
    "ignore": "ตรวจแล้ว",
    "ignore_title": "บรรทัด {{line}} ไม่มีปัญหา",
    "note": "เหตุผล",
    "note_hint": "เช่น ยกเลิกที่เครื่องในวันเดียวกัน",
    "ignored": "ทำเครื่องหมายว่าตรวจแล้ว",
    "fees_title": "ค่าธรรมเนียมตามแบรนด์บัตร",
    "fees_intro": "ยอดที่ระบบคาดจาก % ที่บันทึกไว้ (ระบบคำนวณ)",
    "brand": "แบรนด์",
    "count": "จำนวนครั้ง",
    "fee_suggest_other": "{{brand}}: ผู้ให้บริการคิด {{percent}}% ใน {{count}} รายการ",
    "fee_use": "ใช้ {{percent}}% ต่อจากนี้",
    "fee_confirm_title": "เปลี่ยนค่าธรรมเนียมไหม?",
    "fee_confirm": "การจ่ายด้วย {{brand}} บนเครื่องนี้ใช้ {{percent}}% ต่อจากนี้ การจ่ายที่บันทึกแล้วยังใช้ค่าธรรมเนียมเดิม",
    "fee_confirm_button": "เปลี่ยนค่าธรรมเนียม",
    "fee_set": "{{brand}} ใช้ {{percent}}% แล้ว"
  },
  "refunds": {
    "title": "การคืนเงิน",
    "intro": "การคืนเงินทุกออเดอร์: เท่าไร คืนทางไหน และอยู่ขั้นไหน",
    "order": "ออเดอร์",
    "amount": "ยอด",
    "method": "วิธี",
    "reason": "เหตุผล",
    "status": "สถานะ",
    "who": "ผู้ขอ",
    "approved_by": "อนุมัติโดย {{name}}",
    "date": "วันที่",
    "invoice": "ใบคืนเงิน (返還インボイス)",
    "invoice_open": "เอกสารของออเดอร์",
    "view_open": "ยังต้องทำ",
    "view_done": "เสร็จแล้ว",
    "empty": "ไม่มีการคืนเงิน"
  },
  "refund_method": {
    "original": "วิธีเดียวกับที่จ่าย",
    "cash": "เงินสด",
    "bank_transfer": "โอนธนาคาร",
    "store_credit": "เครดิตร้าน",
    "edc_manual": "เครื่องรูดบัตร"
  },
  "refund_reason": {
    "order_cancelled": "ยกเลิกออเดอร์",
    "return": "คืนสินค้า",
    "overpayment": "จ่ายเกิน",
    "price_adjustment": "แก้ราคา",
    "goodwill": "น้ำใจ",
    "tax_free_refund": "คืนภาษีปลอดภาษี",
    "other": "อื่นๆ"
  },
  "refund_status": {
    "requested": "ขอแล้ว",
    "pending_approval": "รออนุมัติ",
    "approved": "อนุมัติแล้ว",
    "processing": "กำลังทำ",
    "completed": "เสร็จ",
    "failed": "ไม่สำเร็จ",
    "rejected": "ปฏิเสธ"
  },
  "refund_next": {
    "waiting_approval": "ต้องให้อีกคนอนุมัติ",
    "hand_cash": "คืนเงินสด",
    "enter_terminal_reference": "กรอกเลขยกเลิกของเครื่อง",
    "waiting_destination": "รอข้อมูลบัญชีลูกค้า",
    "transfer_money": "โอนเงิน",
    "failed": "ลองอีกครั้ง"
  }
}
